import { create } from "apisauce";
export const firebaseConfig = {
  apiKey: "AIzaSyAtgXMqzYA4iDJqJ5XRFOZE06TtIJqtHpY",
  authDomain: "nailology001.firebaseapp.com",
  databaseURL: "https://nailology001.firebaseio.com",
  projectId: "nailology001",
  storageBucket: "nailology001.appspot.com",
  messagingSenderId: "154985530342",
  appId: "1:154985530342:web:90c8e577c609661afd4c27",
  measurementId: "G-56GC9STC9B",
};
export const fireBaseApi = create({
  baseURL: `https://securetoken.googleapis.com/v1/token?key=${firebaseConfig.apiKey}`,
});
